//
//
//
//
//
//
//
//
//

export default {
  name: 'MuscleStrength_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Neuro/Chart_MuscleStrength_info.vue